import { type ISession } from '@mahawi/eshop-common/src/types';
import { createSlice, type Reducer } from '@reduxjs/toolkit';

import {
  asyncStateInitial,
  finishLoading,
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
  startLoading,
} from '../async-state';
import { type IAdminOrder } from '../orders/types';
import { type IDashboardState } from './types';

export const preloadedState: IDashboardState = {
  ...asyncStateInitial,
  sessions: undefined,
  pendingOrders: undefined,
  pendingInProcess: false,
  pendingUpdatedAt: undefined,
};

const dashboardSlice = createSlice({
  name: 'Dashboard',
  initialState: preloadedState,
  reducers: {
    loadSessions(state) {
      startLoading(state);
    },
    loadSessionsResponse: {
      reducer(state, action: { payload: { sessions: ISession[] } }) {
        state.sessions = action.payload.sessions;
        finishLoading(state);
      },
      prepare(sessions: ISession[]) {
        return { payload: { sessions } };
      },
    },
    dashboardLoadPendingOrders(state) {
      state.pendingInProcess = true;
    },
    dashboardLoadPendingOrdersResponse: {
      reducer(state, action: { payload: { orders: IAdminOrder[] } }) {
        state.pendingOrders = action.payload.orders;
        state.pendingInProcess = false;
        state.pendingUpdatedAt = Date.now();
      },
      prepare(orders: IAdminOrder[]) {
        return { payload: { orders } };
      },
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      requestFailedMatcher('Dashboard'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const {
  loadSessions,
  loadSessionsResponse,
  dashboardLoadPendingOrders,
  dashboardLoadPendingOrdersResponse,
} = dashboardSlice.actions;
const reducer: Reducer<IDashboardState> = dashboardSlice.reducer;

export default reducer;
